"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_video__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.a{stroke:#fecb00;stroke-linejoin:round;stroke-width:8.06px;}.b{fill:#fff;}.c{opacity:0.12;}.c,.d,.e{isolation:isolate;}.d{opacity:0.2;fill:url(#a);}.e{opacity:0.06;}.g{fill:#4a4d4e;}.h{fill:#e60000;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 131.98,
    y1: 107.77,
    x2: 175.17,
    y2: 64.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149,104.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M164.42,61.79,144,72v47.83l20.39,10.3A8,8,0,0,0,176,123V69a8,8,0,0,0-11.58-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M164.42,61.79,144,72v47.83l20.39,10.3A8,8,0,0,0,176,123V69a8,8,0,0,0-11.58-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.27,119.71l-.4-48.11h.5l20.22-9.93a8,8,0,0,1,11.53,7.18V86.2A4,4,0,0,1,175,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M164.42,63.79,144,74V72l20.42-10.21A8,8,0,0,1,176,68.94v2a8,8,0,0,0-11.58-7.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 16.05,
    y: 48,
    width: 127.95,
    height: 96,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 48.89,
    y: 71.01,
    width: 63.83,
    height: 3.99,
    rx: 1.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 40,
    cy: 120,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M128,50H32A16,16,0,0,0,16,66V64A16,16,0,0,1,32,48h96a16,16,0,0,1,16,16v2A16,16,0,0,0,128,50Z"
  }))), /*#__PURE__*/React.createElement("title", null, "video-hi-dark"), /*#__PURE__*/React.createElement("use", {
    width: 192,
    height: 192,
    transform: "matrix(1, 0, 0, -1, 0, 192)",
    xlinkHref: "#b"
  }));
}

var _default = ic_video__dark;
exports.default = _default;